module.exports = __webpack_public_path__ + "img/01020204.b73431ab.svg";